/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnotationSettingsTabComponent } from './annotation-settings-tab.component';
import { SysqueTabModule } from '../../../../../../../../shared/ui/src/lib/components/sysque-tab';
import { ConduitSettingsModule } from './conduit-settings';
import { CableTrayModule } from './cable-tray';

@NgModule({
  declarations: [AnnotationSettingsTabComponent],
  imports: [CommonModule, SysqueTabModule, ConduitSettingsModule, CableTrayModule],
  exports: [AnnotationSettingsTabComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AnnotationSettingsTabModule {}
